import { Button, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";
import { getFieldInputProps } from "core/utils/form";
import { REGEX } from "core/config/constant";
import { _t } from "core/language";
import { validationSchemaForm } from "./Auth.config";
import API from "core/networks/API";
import { API_CHECK_EMAIL, API_SIGNUP } from "../api";
import { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { hideBottomButtonInputFocus } from "core/utils/helper";
import { useLocation } from "react-router-dom";

const SignUpForm = () => {
  const navigate = useCustomNavigate();

  const [errors, setErrors] = useState({
    email:'',
    password:'',
    rePassword:'',
  });
  const [emailTerm, setEmailTerm] = useState('');
  const [signUpModal, setSignUpModal] = useState({state:false});
  const location = useLocation();
  const [signUpByMenu, setSignUpByMenu] = useState('');

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      rePassword: "",
      validSubmit: false,
      validCheckMail: false,
      disabledCheckMail:true,
      disabledSubmit:true,
    },
    
    validate: values => {
      const errors: { email?: string } = {};
      if (values.email && 
        !formik.values.validCheckMail
      ) {
        errors.email = _t('auth.AU_02_MSG_04')
        setErrors({
          email:'',
          password:'',
          rePassword:'',
        })
      }
      if (!REGEX.EMAIL.test(formik?.values.email)) {
        setErrors({
          email:'',
          password:'',
          rePassword:'',
        })
        errors.email = _t('auth.AU_02_MSG_01')
      }
      return errors;
    },
    validationSchema: validationSchemaForm,
    validateOnMount: false, // Prevent validation on page load (default behavior)
    validateOnChange: false, // Validate on field changes
    validateOnBlur: false,   // Validate when a field is blurred
    onSubmit(values, formikHelpers) {
      handleSignUp()
      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });

  const formikRef = useRef(formik);
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);

  useEffect(() => {
    if (formik.values.email && emailTerm !== formik.values.email) {
      formik.setValues((prev) => ({
        ...prev,
        validCheckMail: false,
        validSubmit: false,
        disabledCheckMail: REGEX.EMAIL.test(formik?.values.email) ? false : true,
      }));
      setErrors({
        email:'',
        password:'',
        rePassword:'',
      })
    }else {
      formik.setValues((prev) => ({
        ...prev,
        disabledCheckMail: true,
      }));
      if(!formik.values.email){
        setErrors({
          email:'',
          password:'',
          rePassword:'',
        })
      }
    }
    const isValidSubmit = !!(formikRef.current.values.password && 
      formikRef.current.values.rePassword && 
      formikRef.current.values.email);
    // const isValidSubmitError = (formikRef.current.errors.password || 
    //   formikRef.current.errors.rePassword || 
    //   formikRef.current.errors.email);
    // if (isValidSubmitError) {
    //   formikRef.current.setFieldValue('disabledSubmit', false);
    //   return
    // }
    if (formikRef.current.values.disabledSubmit !== isValidSubmit) {
      formikRef.current.setFieldValue('disabledSubmit', isValidSubmit);
    }
  }, [formik.values.password, formik.values.rePassword, formik.values.email, formik.errors]);

  console.log(formik,'formik123',emailTerm)

  useEffect(() => {
    hideBottomButtonInputFocus()
  }, [])

  useEffect(() => {
    if(location?.search && location?.search.includes('signUpByMenu')){  
      const url = new URLSearchParams(location?.search).get('signUpByMenu');
      if(url){
        setSignUpByMenu(url)
      }
    }
    if(location?.search && location?.search.includes('signUpModal')){  
      setSignUpModal({state:true})
    }
  }, [location])

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSignUp = async () => {

    if (!REGEX.EMAIL.test(formik?.values.email)) {
      formik.setErrors({ email: _t('auth.AU_02_MSG_01') })
      return
    }
    
    const dataRequest = {
      email: formik.values.email,
      password: formik.values.password,
    }
    try {
      const { data: response } = await API.post(`${API_SIGNUP}`, dataRequest)
      if (response && response?.code === 200) {
        navigate(RouterName.SIGNUP_SUCCESS+`${signUpModal.state ? '?signUpModal=true' : ''}`+`${signUpByMenu ? '?signUpByMenu='+signUpByMenu : ''}`)
      }
    } catch (e: any) {
        console.log(e, 'errors');
        formik.setErrors({ email: _t('auth.AU_02_MSG_01') })
        setErrors({
          email:'',
          password:'',
          rePassword:'',
        })
    }

  }
  

  const handleCheckMail = async () => {
    setErrors({
      email:'',
      password:'',
      rePassword:'',
    })
    if (!REGEX.EMAIL.test(formik?.values.email)) {
      formik.setErrors({ email: _t('auth.AU_02_MSG_01') })
      return
    }
    const dataRequest = {
      email: formik.values.email,
    }
    try {
      const { data: response } = await API.post(`${API_CHECK_EMAIL}`, dataRequest)
      if (response && response?.code === 200) {
        formik.setErrors({ email: _t('auth.AU_02_MSG_02') })
      }
    } catch (e: any) {
      
      const codeRes = e.response?.data?.code
      if (!REGEX.EMAIL.test(formik?.values.email)) {
        formik.setErrors({ email: _t('auth.AU_02_MSG_01') })
        formik.setValues((pre) => ({
          ...pre,
          validCheckMail:false,
          email:pre.email
        }))
        return
      }
      if(codeRes === 404){
        
        formik.setValues((pre) => ({
          ...pre,
          validCheckMail:true,
          disabledCheckMail:true
        }))
        setErrors({...errors, email: _t('auth.AU_02_MSG_03') })
        formik.setErrors({...formik.errors,email: ''})
        setEmailTerm(formik.values.email)
      }
    }

  }

  const handleSubmit = (e: any) => {
    // const { onSubmit } = formik;
    
    formik.setValues((pre) => ({
      ...pre,
      validSubmit: true,
    }));
    // onSubmit(e)
    formik.handleSubmit(e)
  };

  
  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader sticky showCart={false} title={_t('auth.LabelSignUp')} handleGoBack={handleGoBack} />
      <div className="">
        <form onSubmit={handleSubmit} className="flex flex-col px-4 py-[50px] w-full tracking-tighter bg-white overflow-y-scroll min-h-[400px]">
          <label className="text-dark text-[13px] font-medium mb-[7px]">{_t('auth.LabelIdEmail')}</label>
          <div className="flex gap-2 min-h-[70px]">
            <CInputControl
              label=""
              placeholder={_t('auth.Email')}
              
              {...getFieldInputProps(formik, 'email')}
              error={formik?.errors?.email}
            />
            <Button onClickBtn={handleCheckMail}
              disabled={formik?.values?.disabledCheckMail}
              label={_t('auth.DuplicateCheck')}
              size="13px"
              type="button"
              classBtn="w-1/3 h-fit !rounded whitespace-nowrap px-[5px]"
            />
          </div>
          { errors?.email && <p className=" text-[11px] tracking-tight text-zinc-800 font-normal mt-[-23px] mb-[5px]">
                { errors?.email}
          </p> }
          <div className="">
            <CInputControl
              className='!min-h-[96px]'
              label={_t('auth.Password')}
              error=""
              maxLength={200}
              type="password"
              placeholder={_t('auth.PlaceHolderPassword')}
              {...getFieldInputProps(formik, 'password')}
            />
            <CInputControl
              label={_t('auth.VerifyPassword')}
              error=""
              maxLength={200}
              type="password"
              placeholder={_t('auth.VerifyPassword')}
              {...getFieldInputProps(formik, 'rePassword')}
            />
          </div>
          <div className="bottom-btn fixed left-0 bottom-0 w-full px-4">
            <Button disabled={!formik.values?.disabledSubmit} size="lg" type="submit" label={_t('auth.LabelSignUp')} primary classBtn="w-full mb-[50px]" />
          </div>
        </form>
      </div >

    </AppLayout >
  );
};

export default SignUpForm;
